module.exports = __webpack_public_path__ + "static/img/4.fe3630d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/index/vip-banner/4.jpg
// module id = 6EtI
// module chunks = 0